import * as React from "react";
import { Stack, Typography } from "@mui/material";
import StarRoundedIcon from "@mui/icons-material/StarRounded";
import StarBorderRoundedIcon from "@mui/icons-material/StarBorderRounded";

export default function StarRating(props: { label: string; value: number; max?: number }) {
  const { label, value, max = 5 } = props;
  const clamped = Math.max(0, Math.min(max, Math.round(value)));

  return (
    <Stack direction="row" alignItems="center" spacing={1}>
      <Typography sx={{ fontSize: 12, color: "rgba(226,232,240,0.7)", minWidth: 96, flexShrink: 0 }}>
        {label}
      </Typography>
      <Stack direction="row" spacing={0.25}>
        {Array.from({ length: max }).map((_, i) =>
          i < clamped ? (
            <StarRoundedIcon key={i} sx={{ fontSize: 16, color: "#FDE68A" }} />
          ) : (
            <StarBorderRoundedIcon key={i} sx={{ fontSize: 16, color: "rgba(226,232,240,0.3)" }} />
          )
        )}
      </Stack>
    </Stack>
  );
}
